<template>
  <div class="main_box">
    <div class="contact_box">
      <h1>Contact cardhobby</h1>
      <div class="card_detail_box" v-if="cardDetail.ID">
        <img src="#" alt="">
        <div class="card_detailbox">
          <div class="card_detail">
            详情
          </div>
          <div class="price">$40.00</div>
          <div class="sPrice_box">
            <span>Shipping:</span>
            <div class="sPrice">$5.00</div>
          </div>
        </div>
      </div>
      <div class="contact_title">Question you my ask</div>
      <el-collapse class="contact_collapse">
        <el-collapse-item class="contact_collapse_item" name="1">
          <template slot="title">
            Shipping(2)
          </template>
          <div class="QA">
            <p class="Q text_gray">Where do you ship from?</p>
            <p class="A">This item ships from Oceanside, California, United States</p>
          </div>
          <div class="QA">
            <p class="Q text_gray">Do you offer international shipping?</p>
            <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping
              fee.</p>
          </div>
        </el-collapse-item>
        <el-collapse-item class="contact_collapse_item" name="2">
          <template slot="title">
            Make an offer(1)
          </template>
          <div class="QA">
            <p class="Q text_gray">Do you offer international shipping?</p>
            <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping
              fee.</p>
          </div>
        </el-collapse-item>
        <el-collapse-item class="contact_collapse_item" name="3">
          <template slot="title">
            Pay for item(1)
          </template>
          <div class="QA">
            <p class="Q text_gray">Do you offer international shipping?</p>
            <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping
              fee.</p>
          </div>
        </el-collapse-item>
        <el-collapse-item class="contact_collapse_item" name="4">
          <template slot="title">
            Returns(1)
          </template>
          <div class="QA">
            <p class="Q text_gray">Do you offer international shipping?</p>
            <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping
              fee.</p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="contact_box">
      <!-- <div class="contact_title">No answer ,want to contact the seller ?
        <a target="_blank" :href="`${$store.getters.CHAT()}&to=@buyer.WyAccId`">
          <span class="text_blue">Instant contact</span>
        </a>
      </div> -->
      <!-- <div class="seller_answer">
        <div class="seller_answer_textarea">
          <div>Write someting to 卖家名称</div>
          <el-input type="textarea" resize="none" :rows="6" v-model="textarea"></el-input>
        </div>
        <p class="text_gray seller_answer_p">To keep everyone safe on Card Hobby,please don't send messages that include contact
          info.Repeated attempts
          could lead to an account suspension or other penalties.</p>
        <el-checkbox v-model="checked">Send a copy to my email address</el-checkbox>
      </div>
      <div class="buyer_anwer" v-if="cardDetail">
        <div class="buyer_name">xxx</div>
        <div class="anwer_box">
          <div class="anwer_list">
            <img src="#" alt="">
            <div class="anwer_message">hello.</div>
          </div>
          <div class="anwer_list">
            <img src="#" alt="">
            <div class="anwer_message">hello.</div>
          </div>
        </div>
        <div class="enter_textarea">
          <el-input type="textarea" resize="none" :rows="6" v-model="textarea"></el-input>
        </div>
      </div> -->
    </div>
    <!-- <div style="padding: 10px 20px 20px;">
      <el-button type="primary" @click="DialogShow = false">Send message</el-button>
      <el-button @click="DialogShow = false">Cancel</el-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ContactBox',
  data() {
    return {
      cardDetail: {}
    }
  },
  props: {
    list: [],
  },
  components: {},
  mounted() {
  },
  methods: {
    getData() {

    },
  }
}
</script>

<style scoped>
h1 {
  font-size: 24px;
  margin: 0 0 24px 0;
}
.contact_title {
  font-size: 18px;
  padding: 16px 0 11px;
}
.contact_box:last-child .contact_title {
  padding: 16px 0;
  font-size: 18px;
}
.el-collapse {
  border-top: none;
}
.el-collapse {
  margin: 3px 0 0;
}
.contact_title span {
  font-size: 16px;
  padding-left: 18px;
  margin-left: 16px;
  background: url(../../../static/images/icons/icon_chat.png) no-repeat;
  cursor: pointer;
}
.seller_answer_textarea {
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  padding: 16px;
}
.seller_answer .el-textarea /deep/ .el-textarea__inner {
  border: none;
}
.seller_answer_textarea div,
.seller_answer_p {
  color: #a0a0a0;
  font-size: 12px;
}
.seller_answer_p {
  margin: 16px 0 8px;
}
.el-checkbox__label {
  font-size: 12px;
}

.el-dialog /deep/ .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: left;
  box-sizing: border-box;
}

.card_detail_box {
  display: flex;
  height: 88px;
  margin: 0 0 34px 0;
}
.card_detail_box img {
  width: 68.5px;
  height: 88px;
}
.card_detailbox {
  margin: 0 0 0 21px;
}
.card_detail {
  height: 36px;
  width: 100%;
  display: block;
}
.price {
  font-size: 14px;
  margin: 6px 0 12px;
}
.sPrice_box {
  display: flex;
  font-size: 16px;
}
.sPrice_box span {
  color: #a0a0a0;
}

.buyer_anwer {
  width: 100%;
  height: 230px;
  margin: 11px 0 0;
}
.buyer_name {
  height: 23px;
  line-height: 23px;
  color: #a0a0a0;
  font-size: 12px;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.1);
  margin: 0 0 6px 0;
}
.anwer_list {
  display: flex;
  margin: 16px 0 0;
}
.anwer_list img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.anwer_message {
  height: 24px;
  background: #f7f7f7;
  border-radius: 2px;
  min-width: 150px;
  margin: 0 0 0 8px;
  padding: 6px 8px;
}
.anwer_box {
  height: 200px;
}
.enter_textarea {
  padding: 8px 12px;
}
.enter_textarea .el-textarea /deep/ .el-textarea__inner {
  background: #f7f7f7;
}
</style>


// WEBPACK FOOTER //
// src/pages/contact/index.vue